export const companyparameterConstants = {
    GETALL_REQUEST: 'COMPANYPARAMETER_GETALL_REQUEST',
    GETALL_SUCCESS: 'COMPANYPARAMETER_GETALL_SUCCESS',
    GETALL_FAILURE: 'COMPANYPARAMETER_GETALL_FAILURE',

    DELETE_REQUEST: 'COMPANYPARAMETER_DELETE_REQUEST',
    DELETE_SUCCESS: 'COMPANYPARAMETER_DELETE_SUCCESS',
    DELETE_FAILURE: 'COMPANYPARAMETER_DELETE_FAILURE'
};
